<template>
  <TaskList
    title="Audit Report"
    taskType="audit_report"
  >
  </TaskList>
</template>

<script>
import TaskList from '@/components/TaskList.vue';

export default {
  components: {
    TaskList
  },
}
</script>
